
  import {defineComponent, onBeforeUnmount, onMounted, ref} from "vue";

  import ModalDialog from "@/components/ModalDialog.vue";

  import {MessageTypes} from "@/components/message-types";
  import Order from "@/model/Order";
  import eventBus from "@/eventbus";
  import OrderChecklistDetailsDialogList from "@/views/Orders/OrderChecklistDetailsDialogList.vue";
  import {AxiosResponse} from "axios";
  import OrderServiceV2, {ChecklistItemDto, OrderChecklistResponse} from "@/service/OrderServiceV2";
  import {t} from "@/mixin/mixins";

  export default defineComponent({
    name: "OrderChecklistDetailsDialog",
    components: {
      OrderChecklistDetailsDialogList,
      ModalDialog
    },
    setup (props, context) {
      const dialog = ref<boolean>(false);
      const order = ref<Order>(new Order());
      const beforeInventoryChecklist = ref<Array<ChecklistItemDto>>(new Array<ChecklistItemDto>());
      const duringInventoryChecklist = ref<Array<ChecklistItemDto>>(new Array<ChecklistItemDto>());
      const afterInventoryChecklist = ref<Array<ChecklistItemDto>>(new Array<ChecklistItemDto>());

      const populateChecklists = (checklist: Array<ChecklistItemDto>) => {
        beforeInventoryChecklist.value = checklist.filter(item => item.phase === "BEFORE");
        duringInventoryChecklist.value = checklist.filter(item => item.phase === "DURING");
        afterInventoryChecklist.value = checklist.filter(item => item.phase === "AFTER");
      };

      const updateChecklist = (item: ChecklistItemDto) => {
        OrderServiceV2.completeChecklistItem(order.value.uuid as string, item.code)
          .then((response: AxiosResponse<ChecklistItemDto>) => {
            const replace = (checklist: Array<ChecklistItemDto>) => checklist
              .map(current => current.code === response.data.code ? response.data : current);
            beforeInventoryChecklist.value = replace(beforeInventoryChecklist.value);
            duringInventoryChecklist.value = replace(duringInventoryChecklist.value);
            afterInventoryChecklist.value = replace(afterInventoryChecklist.value);
            eventBus.$emit(MessageTypes.SNACKBAR_SUCCESS, t("inventoryChecklist.statusUpdateSuccess"));
          })
          .catch(function () {
            item.completed = false;
            eventBus.$emit(MessageTypes.ERROR, t("inventoryChecklist.statusUpdateError"));
          });
      };

      const closeDialog = () => {
        dialog.value = false;
        order.value = new Order();
      };

      onMounted(() => {
        eventBus.$on(MessageTypes.OPEN_ORDER_CHECKLIST_DETAILS, (orderUuid: string) => {
          dialog.value = true;

          OrderServiceV2.getOrderByUuid(orderUuid)
            .then((loadedOrder: Order) => {
              order.value = loadedOrder;
              return OrderServiceV2.getOrderChecklist(orderUuid);
            })
            .then((response: AxiosResponse<OrderChecklistResponse>) => {
              populateChecklists(response.data.items);
            });
        });
      });

      onBeforeUnmount(() => {
        eventBus.$off(MessageTypes.OPEN_ORDER_CHECKLIST_DETAILS, () => {
          closeDialog();
        });
      });

      return {
        dialog,
        order,
        beforeInventoryChecklist,
        duringInventoryChecklist,
        afterInventoryChecklist,
        updateChecklist,
        closeDialog
      };
    }
  });
